import client from "../modules/client";
import HelperService from "./helper-service";

export const getList = (filter) => {
  let query = HelperService.getFilterQueryString({
    lat:filter.lat,
    lon:filter.lon,
    radius:HelperService.getRadius(filter),
    keyword:filter.search,
    categories:filter.categories,
    limit:20,
    offset:filter.offset || 0
  });
  return client(`/api/v1/trainers?${query}`).then(({ data }) => data);
};

export const getDetail = (id) => {
  return client(`/api/v0/users/${id}`).then(({ data }) => data?.profile);
};

export const getCourses = (id) => {
  return client(`/api/v0/trainers/${id}/courses?limit=20&offset=0`).then(({ data }) => data);
};

export const getCourseDetail = (id) => {
  return client(`/api/v0/courses/${id}`).then(({ data }) => data);
};

export const getEvents = (id, filter) => {
  let query = HelperService.getFilterQueryString({
    from: filter.from || (new Date()).getTime(),
    upcoming: filter.upcoming,
  });
  return client(`/api/v0/users/${id}/events?${query}`).then(({ data }) => data.events);
};

export function useTrainerService () {
  return {
    getList,
    getDetail,
    getCourses,
    getEvents,
    getCourseDetail,
  };
}
